/**
 * The YouTube player card.
 *
 * The mount point has to exist before the iframe API is asked to build a
 * player into it, so the card is always in the DOM — hidden, not unmounted,
 * while a demo record is playing.
 */

import { type Component, createSignal } from 'solid-js';
import { youtubeCardOpen } from '../../state/ui.ts';
import { ChevronDown } from '../icons/nav.tsx';
import glass from '../primitives/Glass.module.css';
import styles from './YouTubeCard.module.css';

export const YouTubeCard: Component = () => {
  const [collapsed, setCollapsed] = createSignal(false);

  return (
    <div
      data-testid="youtube-card"
      class={[
        glass.glass,
        styles.card,
        {
          [styles.collapsed as string]: collapsed(),
          [styles.hidden as string]: !youtubeCardOpen(),
        },
      ]}
    >
      <div class={styles.head}>
        <span>YouTube player</span>
        <button
          type="button"
          aria-label={collapsed() ? 'Expand player' : 'Collapse player'}
          onClick={() => setCollapsed((c) => !c)}
        >
          <ChevronDown />
        </button>
      </div>
      <div class={styles.body}>
        <div id="yt-mount" class={styles.mount} />
      </div>
    </div>
  );
};
